export default __webpack_public_path__ + "static/media/misc-books5-768w.b2ed294c.avif";